import { useState } from 'react';
import { useAuth } from '../Auth/store';
import { Button as CustomButton } from "../Buttons/button";
import IcoExpand from '../../images/arrow-expand.svg';
import IcoCollapse from '../../images/ico_collapse.svg';
import IcoWarning from '../../images/ico_warning.svg';
import References from '../../helpers/Reference';

export const LeftMenu = () => {

    const [ isExpand, setIsExpand ] = useState( false );
    const {permission} = useAuth()

    const onShowHideBtnClick = () => {
        setIsExpand(!isExpand);
    }

    if (!permission?.permissions.can_view_event_data) 
        return <></>

    return <>
        <CustomButton 
            id="left_menu_btn_expand"
            position={{left: 10, top: 10}}
            type="circle"
            icon={IcoExpand}
            tooltip={{
                title: References.dictionary.tooltips.button_open_menu
            }}
            size="md"
            handleClick={onShowHideBtnClick}
        />
        <div id="left-menu" className={isExpand ? "left-menu-expand" : "left-menu-collapse"}>
            <CustomButton
                id="left_menu_btn_collapse"
                position={{left: 15, top: 10}}
                type="circle"
                icon={IcoCollapse}
                tooltip={{
                    title: References.dictionary.tooltips.button_hide_menu
                }}
    
                size="md"
                handleClick={onShowHideBtnClick}        
            />
            <div className="lefmtnuTitle item1">Свернуть</div>            

            <CustomButton
                id="left_menu_btn_event"
                position={{left: 15, top: 100}}
                type="circle"
                icon={IcoWarning}
                tooltip={{
                    title: References.dictionary.tooltips.button_go_event
                }}

                size="md"
                children={<>
                    <a href="/event"></a>
                </>}
            />
            <div className="lefmtnuTitle item2">События</div>
        </div>
    </>;
}